/**
 * 화면 관리자 — `#overlay` 한 장을 여러 화면(타이틀·부활·게임오버·결과 카드·자가표기)이 공유한다.
 * 한 번에 하나만 열리고, 열 때 클래스와 내용을 통째로 재설정한다.
 * 이게 없으면 부활 오버레이가 게임오버 패널을 영구히 막고, 이전 화면의 레이아웃 클래스가
 * 다음 화면에 그대로 걸린다(UPLIFT §3.1).
 */
export type ScreenId = 'boot' | 'title' | 'challenge' | 'survey' | 'revive' | 'gameover' | 'card';

export interface ScreenHandle {
  readonly id: ScreenId;
  close(): void;
}

export interface ScreenHost {
  /** 이전 화면을 닫고 연다. overlay.className = `on ${id}` 로 통째 재설정한다. */
  open(id: ScreenId, render: (root: HTMLElement) => void): ScreenHandle;
  current(): ScreenId | null;
  /** id 를 주면 그 화면일 때만 닫는다(경합 방어). */
  close(id?: ScreenId): void;
}

export function createScreens(overlay: HTMLElement): ScreenHost {
  let cur: ScreenId | null = null;
  const host: ScreenHost = {
    open(id, render) {
      overlay.className = `on ${id}`;
      overlay.innerHTML = '';
      cur = id;
      render(overlay);
      return {
        id,
        close: () => host.close(id),
      };
    },
    current: () => cur,
    close(id) {
      if (id !== undefined && cur !== id) return;
      overlay.className = '';
      overlay.innerHTML = '';
      cur = null;
    },
  };
  return host;
}
